var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBehanceIconb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "behance-svgrepo-com",
    transform: "translate(-4.5 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43833",
    "data-name": "Path 43833",
    d: "M7.176,5.5A1.676,1.676,0,0,0,5.5,7.176V34.824A1.676,1.676,0,0,0,7.176,36.5H34.824A1.676,1.676,0,0,0,36.5,34.824V7.176A1.676,1.676,0,0,0,34.824,5.5Z",
    fill: "none",
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43834",
    "data-name": "Path 43834",
    d: "M32.859,28.337a3.165,3.165,0,0,1-2.751,1.6h0a3.166,3.166,0,0,1-3.166-3.166V24.71a3.166,3.166,0,0,1,3.166-3.166h0a3.166,3.166,0,0,1,3.166,3.166v1.029H26.941",
    transform: "translate(-3.477 -2.602)",
    fill: "none",
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43835",
    "data-name": "Path 43835",
    d: "M18.725,22.774a3.166,3.166,0,1,1,0,6.333H13.5V16.441h5.225a3.166,3.166,0,1,1,0,6.333Z",
    transform: "translate(-1.297 -1.774)",
    fill: "none",
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_162",
    "data-name": "Line 162",
    x1: 5.225,
    transform: "translate(12.203 21)",
    fill: "none",
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_163",
    "data-name": "Line 163",
    x2: 6.333,
    transform: "translate(23.465 14.667)",
    fill: "none",
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehanceIconb);
export default __webpack_public_path__ + "static/media/behance-iconb.e9da57b23ae51d37620dc11a2220997c.svg";
export { ForwardRef as ReactComponent };